DealLazyLoader = window.DealLazyLoader =
  init: (payload, done) ->
    $(document.body).on 'modal-open', (e, data) ->
      window.Groupon.Utils.lazyLoadImages($('#' + data.id).find('.lazy-load'))

    window.Groupon.Utils.lazyLoadImages $('.sleepy-load:not(.lazy-loaded), .lazy-load:not(.lazy-loaded)'), { skip_invisible: true }

    done()

module.exports = DealLazyLoader
